import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { ViewSupplierServiceService } from '../view-supplier-service.service';
import { appConfig } from '../app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  config: any;

  constructor(private commonService:CommonService,public viewSupplierApi:ViewSupplierServiceService,private http: HttpClient) {
this.config = appConfig;
   }
    getServiceCall(url: any,_query='') : Observable<any> {
   
       let idpToken = localStorage.getItem('IDPAccessToken') || '';
   if(this.commonService.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
     if(this.commonService.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
       idpToken= this.viewSupplierApi.createToken();
     }
   }
       let headers = {
         headers: new HttpHeaders({
           Authorization: `Bearer ${idpToken}`,
         })
       }
       
      
       return this.commonService.handleApiError(this.http.get(url,headers) )as Observable<any>;
   
     }
     postServiceCall(apiUrl, data: any): Observable<any> {
      let idpToken = localStorage.getItem('IDPAccessToken');
      if(this.commonService.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
        if(this.commonService.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
          idpToken= this.viewSupplierApi.createToken();
        }
      }
      let headers = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${idpToken}`,
        })
      }
         
          return this.http.post(apiUrl,data, headers)as Observable<any>  ;
        
    }
    deleteServiceCall(apiUrl) : Observable<any>{
      let idpToken = localStorage.getItem('IDPAccessToken');
      if(this.commonService.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
        if(this.commonService.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
          idpToken= this.viewSupplierApi.createToken();
        }
      }
      let headers = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${idpToken}`,
        })
      }
     
      return this.commonService.handleApiError( this.http.delete(apiUrl, headers)) as Observable<any>
    }
}
